import { IssueStatusEnum } from '../../types';
export const DEFAULT_ACTIVE_STATUSES = [
    IssueStatusEnum.Detected,
    IssueStatusEnum.Skipped,
    IssueStatusEnum.Suggested,
    IssueStatusEnum.CorrectionSuggested
];
export const EMPTY_FILTERS = {
    issueTypes: [],
    statuses: DEFAULT_ACTIVE_STATUSES,
    inspectableTypes: [],
    impact: null,
    search: ''
};
